exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}.head{background-color:#5d6670;padding:20px 0 40px}h1,h2{font-weight:400;color:#fff}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#42b983}input,select{background-color:#fff;color:#2c3e50;font-size:1.3em;padding:10px;width:250px;border:2px solid #42b983;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d8a8403","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 15
// module chunks = 0